// app/javascript/users/follow_ups/index.js

import './triggers'
